import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PRODUCT_OPTIONS = [
	{ value: 'ETOH', display: 'ETOH' },
	{ value: 'E85', display: 'E85' },
];

export default class FMPProductMultiSelect extends PureComponent {
	render() {
		const { label, value, path, onChange, error, helpText, md, disabled } = this.props;

		const _onChange = (event, onChangeValue) => {
			if (_.isEmpty(onChangeValue)) {
				onChange([], path);
				return;
			}
			const productIds = _.map(onChangeValue, 'value');
			onChange(productIds, path);
		};

		const selectedOptions = [];
		(value || []).forEach((id) => {
			selectedOptions.push(_.find(PRODUCT_OPTIONS, { value: id }));
		});

		const hasError = !!error;
		return (
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>
					<Autocomplete
						multiple
						options={PRODUCT_OPTIONS}
						value={selectedOptions}
						disableCloseOnSelect
						onChange={_onChange}
						getOptionLabel={(option) => option.display}
						getOptionSelected={(option, value) => {
							return option.value === value.value;
						}}
						renderOption={(option, { selected }) => (
							<React.Fragment>
								<Checkbox
									size={'small'}
									icon={icon}
									checkedIcon={checkedIcon}
									style={{ marginRight: 8 }}
									checked={selected}
								/>
								{option.display}
							</React.Fragment>
						)}
						renderInput={(params) => (
							<TextField {...params} label={label} placeholder="Pick multiple" fullWidth />
						)}
					/>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);
	}
}

FMPProductMultiSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	md: PropTypes.number,
	helpText: PropTypes.string,
	disabled: PropTypes.bool,
};

FMPProductMultiSelect.defaultProps = {
	label: 'Product',
	md: 12,
};
